import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/two_factor.svg'


const _hoisted_1 = { class: "code-two-factor-content" }
const _hoisted_2 = ["maxlength", "onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_3 = { style: {"height":"var(--semantic-spacing-stack-600, 48px)"} }
const _hoisted_4 = {
  key: 0,
  class: "sub-title",
  style: { color: `#C63D3D`, margin: `8px` }
}
const _hoisted_5 = { class: "button-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["FontAwesomeIcon"], {
      class: "back-btn",
      icon: $setup.Icons.imported.faArrowLeft,
      onClick: $setup.backButton
    }, null, 8 /* PROPS */, ["icon"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\" Two Factor\" data-v-5643c4b6><div style=\"height:var(--semantic-spacing-stack-300, 24px);\" data-v-5643c4b6></div><div class=\"d-flex flex-column gap-2\" data-v-5643c4b6><h1 class=\"title\" data-v-5643c4b6>Insira o código</h1><b class=\"sub-title\" data-v-5643c4b6>Digite abaixo o <b data-v-5643c4b6>código</b> enviado ao aplicativo de <b data-v-5643c4b6>Autenticação</b> em seu telefone celular.</b></div><div style=\"height:var(--semantic-spacing-stack-400, 32px);\" data-v-5643c4b6></div>", 4)),
      _createElementVNode("form", {
        class: "input-qr-code-container",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        autocomplete: "new-password"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.codeInputs, (_, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("input", {
            maxlength: $setup.maxLength,
            key: index,
            ref_for: true,
            ref: (el => $setup.inputRefs[index] = el as HTMLInputElement),
            "onUpdate:modelValue": ($event: any) => (($setup.codeInputs[index]) = $event),
            class: "input-qr-code",
            type: "text",
            onPaste: $setup.handlePaste,
            onInput: (e) => $setup.handleInput(e, index),
            onKeydown: (e) => $setup.handleKeyboardEvent(e, index),
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-code-input-change', $setup.codeInputs.join(''))))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)), [
            [_vModelText, $setup.codeInputs[index]]
          ])
        }), 128 /* KEYED_FRAGMENT */))
      ], 32 /* NEED_HYDRATION */),
      _createElementVNode("div", _hoisted_3, [
        ($setup.errorText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createElementVNode("b", null, _toDisplayString($setup.errorText), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode($setup["CommonButton"], {
        class: "w-100",
        action: $setup.codeInputs.join('').length === 6 ? 'cta' : 'disabled',
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.validateCode())),
        text: "Enviar código"
      }, null, 8 /* PROPS */, ["action"]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-200, 16px)"} }, null, -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode($setup["CommonButton"], {
          type: "text",
          icon: $setup.Icons.imported.faWhatsapp,
          text: "Pedir ajuda ao suporte",
          onClick: _cache[3] || (_cache[3] = () => $setup.WhatsappUtils.textNumber($setup.Constants.foodPassSupportNumber)),
          style: {"color":"var(--semantic-color-fg-default, #5D5867)"}
        }, null, 8 /* PROPS */, ["icon"])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}